import { Currency, Language } from '@/lib/interfaces/interfaces'
import { ArrowLeft, ShoppingCartIcon, Trash2 } from 'lucide-react'
import { formatMoney } from '@/lib/utils/format'

interface Props {
  total: number
  whatToShow: 'cartList' | 'shippingDetails'
  handleSubmitClick: () => void
  handleSecondaryBtnClick: () => void
  nItems: number
  deliveryFee: number
  minOrder: number
  loading: boolean
  language: Language
  currency: Currency
}

// Objeto de traducciones para cada idioma
const translations = {
  es: {
    total: 'Total:',
    shippingFee: '+ gastos de envío',
    primaryMinOrder: 'Pedido mínimo',
    continue: 'Continuar',
    submitOrder: 'Realizar pedido',
    emptyCart: 'Vaciar carrito',
    back: 'Volver'
  },
  en: {
    total: 'Total:',
    shippingFee: '+ shipping fee',
    primaryMinOrder: 'Minimum order',
    continue: 'Continue',
    submitOrder: 'Place order',
    emptyCart: 'Empty cart',
    back: 'Back'
  },
  fr: {
    total: 'Total :',
    shippingFee: '+ frais de livraison',
    primaryMinOrder: 'Commande minimale',
    continue: 'Continuer',
    submitOrder: 'Passer la commande',
    emptyCart: 'Vider le panier',
    back: 'Retour'
  },
  ca: {
    total: 'Total:',
    shippingFee: '+ despeses d\'enviament',
    primaryMinOrder: 'Comanda mínima',
    continue: 'Continuar',
    submitOrder: 'Realitzar comanda',
    emptyCart: 'Buidar cistella',
    back: 'Tornar'
  },
  de: {
    total: 'Gesamt:',
    shippingFee: '+ Versandkosten',
    primaryMinOrder: 'Mindestbestellung',
    continue: 'Weiter',
    submitOrder: 'Bestellung aufgeben',
    emptyCart: 'Warenkorb leeren',
    back: 'Zurück'
  },
  eu: {
    total: 'Guztira:',
    shippingFee: '+ bidalketa gastuak',
    primaryMinOrder: 'Eskaera minimoa',
    continue: 'Jarraitu',
    submitOrder: 'Eskaera egin',
    emptyCart: 'Hustu saskia',
    back: 'Itzuli'
  }
}

const ActionButtons = ({
  handleSecondaryBtnClick,
  handleSubmitClick,
  total,
  whatToShow,
  nItems,
  deliveryFee,
  minOrder,
  loading,
  language,
  currency
}: Props) => {
  const texts = translations[language] || translations.es

  let primaryBtnText = ''
  if (whatToShow === 'cartList') {
    if (total < minOrder) {
      primaryBtnText = `${texts.primaryMinOrder} ${formatMoney(minOrder, currency)}`
    } else {
      primaryBtnText = texts.continue
    }
  }

  return (
    <div className='orderingCart__footer'>
      <div className='orderingCart__footer__total'>
        <span className='orderingCart__footer__total-label'>{texts.total}</span>
        <span className='orderingCart__footer__total-amount'>{formatMoney(total, currency)}</span>
      </div>
      <div className='orderingCart__footer__shipping'>
        <span>{texts.shippingFee}</span>
        <span>{formatMoney(deliveryFee, currency)}</span>
      </div>
      <div className='orderingCart__footer__actions'>
        <button
          className='orderingCart__btn orderingCart__btn--primary'
          disabled={nItems === 0 || total < minOrder || loading}
          onClick={handleSubmitClick}
        >
          {whatToShow === 'shippingDetails' && <ShoppingCartIcon size={18} />}
          <span>
            {loading ? 'Cargando...' : (whatToShow === 'cartList' ? primaryBtnText : texts.submitOrder)}
          </span>
        </button>
        <button
          className='orderingCart__btn orderingCart__btn--secondary'
          onClick={handleSecondaryBtnClick}
          disabled={loading}
        >
          {whatToShow === 'cartList' ? <Trash2 size={18} /> : <ArrowLeft size={18} />}
          <span>{whatToShow === 'cartList' ? texts.emptyCart : texts.back}</span>
        </button>
      </div>
    </div>
  )
}

export default ActionButtons
